import {Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder} from '@angular/forms';

declare let $: any;

@Component({
   selector: 'app-delete-dialog',
   templateUrl: './delete-dialog.component.html',
   styleUrls: ['./delete-dialog.component.css']
})
export class DeleteDialogComponent implements OnInit {
   public thumbnailSelectedDel = [];
   public totalPages: any;
   sender: any;
   progress: boolean;
   email: any;
   public data2: any = false;
   public isDeleteDocument = false;
   public taskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: '',
      priority: 0,
      templateId: 0,
      workflowId: 0,
      currentLevel: 1,
      apvLevel: [],
      docList: [],
      message: ''
   };
   public indexSelect;

   constructor(private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<DeleteDialogComponent>,
               private translate: TranslateService,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   ngOnInit() {
      if (this.data.index === undefined) {
         this.onCheckSelectDelItems();
      } else {
         this.thumbnailSelectedDel.push(this.data.index + 1);
      }
      this.indexSelect = this.data.createTaskSignOffComp.currentIndex;
   }

   /** check thumbnails ที่ถูกเลือก และค่าไว้ที่ตัวแปร thumbnailSelectedDel แบบ array */
   onCheckSelectDelItems() {
      const thumbnailSelect = this.data.createTaskComp.getThumbnailsSelected();
      for (let i = 0; i < thumbnailSelect.length; i++) {
         if (thumbnailSelect[i].isSelected) {
            this.thumbnailSelectedDel.push(i + 1);
         }
      }
   }

   /** เมื่อกดปุ่มตกลง จะทำการลบ thumbnails ที่เลือกไว้ และ refresh เอกสาร */
   onClickOk() {
      this.progress = true;
      this.data.createTaskSignOffComp.zoomOutAndUpdateSign();
      if (this.data.createTaskSignOffComp !== undefined) {
         this.data.createTaskSignOffComp.handleWaitAction(true);
         this.data.service.deleteThumbnailDocument(this.data.createTaskSignOffComp.getDocId(), this.thumbnailSelectedDel,
            this.data.createTaskSignOffComp.getLenDocument(), this.data.createTaskSignOffComp.getMaxPageDocuments(),
            this.data.createTaskSignOffComp.taskAttribute.taskId)
            .subscribe((response) => {
                  this.dialogRef.close({response: response});
                  this.data.toast.success(response.message);

               },
               (error1) => {
                  this.dialogRef.close();
                  this.data.toast.error(error1);
               });
      }
   }
}

